import React from 'react';
import clsx from 'clsx';
import { AImage } from '../../atoms/AImage/index';
import { MTextBlockBasic } from '../../molecules/MTextBlockBasic/index';
import { MButton } from '../../molecules/MButton/index';
import type { OBannerInlineProps } from './OBannerInline.types';
import * as Styled from './OBannerInline.styles';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OBannerInline';
const TEST_ID = 'mi-web-ui-kit-OBannerInline';

export const OBannerInline: React.FC<OBannerInlineProps> = ({
  aImage,
  mTextBlockBasic,
  mButton,
  className,
  trackingProperties,
  ...rest
}) => {
  const containerClasses = clsx('o-banner-inline', className);

  return (
    <Styled.Container className={containerClasses} data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      {aImage && (
        <Styled.ImageWrapper>
          <AImage {...aImage} />
        </Styled.ImageWrapper>
      )}
      <Styled.ContentWrapper>
        {mTextBlockBasic && (
          <Styled.TextBlockWrapper>
            <MTextBlockBasic {...mTextBlockBasic} />
          </Styled.TextBlockWrapper>
        )}
        {mButton && (
          <Styled.ButtonWrapper>
            <MButton {...mButton} trackingProperties={trackingProperties} />
          </Styled.ButtonWrapper>
        )}
      </Styled.ContentWrapper>
    </Styled.Container>
  );
};
